import React, { createContext, useContext as useContextCore } from 'react'
import type { Colors } from '@ztechapps/common.hook'
import { ThemeProvider, ToastProvider } from '@ztechapps/webui.util'
import { DependencyProvider } from '@ztechapps/webui.contract'
import { setupContainer } from '../../config/setup-container'

export type AppContextType = {
  data?: any
}

const context = createContext<AppContextType>(null as any)
const CoreProvider = context.Provider

const themeColors: Colors = {
  primary: '#0C2B4E', // OwnText primary (dark navy blue)
  primary75: '#1a4a7a',
  primary50: '#3d6a9a',
  primary25: '#7a9bbd',
}

const container = setupContainer()

export const AppContextProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <DependencyProvider container={container}>
      <CoreProvider value={{}}>
        <ToastProvider>
          <ThemeProvider routerType="react-router" colors={themeColors}>
            {children}
          </ThemeProvider>
        </ToastProvider>
      </CoreProvider>
    </DependencyProvider>
  )
}

export const useAppContext = () => useContextCore(context)
